var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inertia-link',{attrs:{"href":'/'}},[_c('img',{attrs:{"src":"/image/logo.png","alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }